import api from './api';

export const epicService = {
  getAll: async (params = {}) => {
    const response = await api.get('/epics', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/epics/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/epics', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/epics/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/epics/${id}`);
    return response.data;
  },

  getTasks: async (epicId) => {
    const response = await api.get(`/epics/${epicId}/tasks`);
    return response.data;
  },
};

export default epicService;
